import { ofType, combineEpics } from 'redux-observable';
import { map as rxmap, mergeMap, takeUntil, exhaustMap } from 'rxjs/operators';

import { rx, api } from 'core/api';
import { actions as processorActions } from 'core/redux/api/processors/actions';
import { errorMap } from 'core/redux/actions';

const actions = processorActions.downsampledMessageHistory;

const addEpic = (action$) => {
	return action$.pipe(
		ofType(actions.add.request.type),
		mergeMap(action =>
			rx(api.processors.downsampledMessageHistoryProcessor.add, action.data).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.add.fail),
				takeUntil(action$.pipe(ofType(actions.add.cancel.type)))
			)
		)
	)
}

const loadEpic = (action$) => {
	return action$.pipe(
		ofType(actions.load.request.type),
		exhaustMap(action =>
			rx(api.processors.downsampledMessageHistoryProcessor.load).pipe(
				rxmap(operation => actions.load.success({ processors: operation.response() })),
				errorMap(actions.load.fail),
				takeUntil(action$.pipe(ofType(actions.load.cancel.type)))
			)
		)
	)
}

const updateEpic = (action$) => {
	return action$.pipe(
		ofType(actions.update.request.type),
		mergeMap(action =>
			rx(api.processors.downsampledMessageHistoryProcessor.update, action.processorId, action.data).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.update.fail),
				takeUntil(action$.pipe(ofType(actions.update.cancel.type)))
			)
		)
	)
}

const removeEpic = (action$) => {
	return action$.pipe(
		ofType(actions.remove.request.type),
		mergeMap(action =>
			rx(api.processors.downsampledMessageHistoryProcessor.remove, action.processorId).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.remove.fail),
				takeUntil(action$.pipe(ofType(actions.remove.cancel.type)))
			)
		)
	)
}

const epic = combineEpics(addEpic, loadEpic, updateEpic, removeEpic);

export { epic };
